// @flow

import React from 'react';
import { useFormik } from 'formik';
import { connect } from 'react-redux';
import type { SignUpReq } from '../../types/account';
import locale from '../../assets/locale';
import { validatePassword } from '../../utils/validators';
import Card from '../../components/Card';
import { H2 } from '../../components/Typography';
import Input from '../../components/Input';
import Button from '../../components/Button';
import routes from '../../constants/routes';
import styles from './styles.module.scss';
import Checkbox from '../../components/Checkbox';
import { signUp as signUpAction } from '../../store/auth/actions';
import P from '../../components/Typography/P';
import CustomLink from '../../components/CustomLink/Link';
import { useLocation } from 'react-router';

type OwnProps = {|
|};

type Props = {
  ...OwnProps,
  signUp: (value: SignUpReq) => void,
  isSignUpInProgress: boolean,
};

const SignUp = ({ signUp, isSignUpInProgress }: Props) => {
  const refCode = new URLSearchParams(useLocation().search).get('referral_code');

  const initialFormState: SignUpReq = {
    email: '',
    password: '',
    confirmPassword: '',
    referralCode: refCode || '',
    isAgreed: false,
  };

  const formik = useFormik({
    initialValues: initialFormState,

    validateOnBlur: false,
    validateOnChange: false,

    onSubmit: (e) => {
      signUp(e);
    },

    validate: (values) => {
      const errors = {};

      if (!values.email) {
        errors.email = locale.errors.account.email;
      }

      if (!validatePassword(values.password)) {
        errors.password = locale.errors.account.password;
      }

      if (!values.confirmPassword) {
        errors.confirmPassword = locale.errors.account.confirmPassword;
      }

      if (values.password !== values.confirmPassword) {
        errors.password = locale.errors.password.notMatch;
        errors.confirmPassword = locale.errors.password.notMatch;
      }

      if (!values.isAgreed) {
        errors.isAgreed = locale.errors.account.isAgreed;
      }

      return errors;
    },
  });

  const { values, errors, dirty } = formik;

  const isButtonDisabled = !dirty;
  return (
    <form onSubmit={formik.handleSubmit}>
      <Card
        use="light"
        className={styles.containerForm}
        title={<H2 color="dark" className={styles.title}>Sign Up</H2>}
      >
        <P use="dark">Email</P>
        <Input
          value={values.email}
          onChange={formik.handleChange}
          name="email"
          error={errors.email}
        />
        <P use="dark">Password</P>
        <Input
          value={values.password}
          name="password"
          onChange={formik.handleChange}
          type="password"
          error={errors.password}
        />
        <P use="dark">Confirm password</P>
        <Input
          value={values.confirmPassword}
          name="confirmPassword"
          onChange={formik.handleChange}
          type="password"
          error={errors.confirmPassword}
        />
        <P use="dark">Referral code (if you have it)</P>
        <Input
          value={values.referralCode}
          name="referralCode"
          onChange={formik.handleChange}
        />
        <Checkbox
          className={styles.checkboxWrapper}
          checked={values.isAgreed}
          name="isAgreed"
          label="I agree to all policies and terms"
          onChange={formik.handleChange}
          error={errors.isAgreed}
        />
        <div className={styles.buttonWrapper}>
          <Button
            type="submit"
            name="SIGN UP"
            use="superBlue"
            fill
            loading={isSignUpInProgress}
            disabled={isButtonDisabled}
          />
        </div>
        <div className={styles.textLink}>
          <P use="dark">Already have an account?</P>
          <CustomLink name="Log in here" use="black" to={routes.auth.signIn.root} />
        </div>
      </Card>
    </form>
  );
};

const mapStateToProps = (state) => ({
  isSignUpInProgress: state.api.SIGN_UP.loading,
});

export default connect(mapStateToProps, {
  signUp: signUpAction.default,
})(SignUp);
